import chatttSDK from 'services/chattt';

// eslint-disable-next-line import/prefer-default-export
export function isURL(target: string) {
  try {
    const url = new URL(target);

    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
}

export const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const isInElectron = !!chatttSDK && chatttSDK?.version > 0;
export const isInBrowser = !isInElectron;

// 是否是 Windows 10 以下系统
export const isBelowWindows10 = () => {
  const userAgent = navigator.userAgent;
  return userAgent.includes('Windows NT 6.');
};

export const isAuthStatusValid = (authStatus: any): authStatus is 'AUTH' | 'AUTH_BE_ABOUT_EXPIRE' =>
  authStatus === 'AUTH' || authStatus === 'AUTH_BE_ABOUT_EXPIRE';

export const isDefaultHangUp = (orgId?: number) =>
  import.meta.env.VITE_ENV === 'production' && [7289, 32729, 8554].includes(orgId);

export const isIdEqual = (id1?: number | string | null, id2?: number | string | null) => {
  if (id1 === null || id2 === null || id1 === undefined || id2 === undefined) {
    return id1 === id2;
  }

  return `${id1}` === `${id2}`;
};

export const isInCN = () => {
  const code = chatttSDK?.app.getLocaleCountryCode() ?? '';
  return /^CN$/i.test(code);
};
